"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cross = exports.ToolIcon = void 0;
require("core-js/modules/es6.object.assign");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("@components/atoms");
const _theme_1 = require("@theme"); // Component
var SiteHeaderTool = function SiteHeaderTool(_ref) {
    var onClick = _ref.onClick, active = _ref.active, noMobile = _ref.noMobile, children = _ref.children;
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, Object.assign({
        noMobile: noMobile,
        onClick: onClick
    }, {
        className: active ? 'active' : ''
    }), /*#__PURE__*/ react_1.default.createElement(exports.ToolIcon, {
        withMobile: true,
        className: active ? 'active' : ''
    }, children), /*#__PURE__*/ react_1.default.createElement(exports.Cross, {
        className: active ? 'active' : ''
    }));
}; // Styling
var Wrapper = styled_components_1.default.li.withConfig({
    displayName: "SiteHeaderTool__Wrapper",
    componentId: "wp55yo-0"
})(["position:relative;display:", ";align-items:center;height:100%;padding:0 12px;text-shadow:0.5px 0.5px 0px rgba(0,0,0,0.24);transition:0.2s background-color ease-in-out;cursor:pointer;&::before{z-index:-1;position:absolute;top:0;bottom:0;left:0;right:0;background-color:", ";transform-origin:center top;transform:scaleY(0);transition:transform 0.4s ease-in-out;will-change:transform;content:'';}&.active::before{transform-origin:center bottom;transform:scaleY(1);}@media only screen and (min-width:", "){padding:0 20px;display:flex;&:hover::before{transform-origin:center bottom;transform:scaleY(1);}}"], function (props) {
    return !props.noMobile ? 'flex' : 'none';
}, _theme_1.palette.karaka, _theme_1.breakpoint.tablet);
exports.ToolIcon = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(atoms_1.Icon, props);
}).withConfig({
    displayName: "SiteHeaderTool__ToolIcon",
    componentId: "wp55yo-1"
})(["opacity:1;transition:opacity   0.35s 0.5s ease-in-out,transform 0.35s 0.5s ease-in-out;will-change:opacity,transform;&.active{opacity:0;transform:scale3d(1.15,1.15,1);transition-delay:0s;}"]);
exports.Cross = styled_components_1.default.div.withConfig({
    displayName: "SiteHeaderTool__Cross",
    componentId: "wp55yo-2"
})(["position:absolute;z-index:-1;left:calc(50% - 8px);display:flex;justify-content:center;align-items:center;width:16px;height:14px;opacity:0;transition:opacity 0.35s 0.25s ease-in-out;&::before,&::after{position:absolute;background-color:", ";height:2px;width:100%;border-radius:0 1px 1px 0;content:'';transform:rotate3d(0,0,1,0deg);transition:all 0.35s ease-in-out;}&.active{opacity:1;transition-delay:0.25s;&::before,&::after{transition-delay:0.25s;}&::before{transform:rotate3d(0,0,1,45deg);}&::after{transform:rotate3d(0,0,1,-45deg);}}"], function (props) {
    return props.color ? props.color : _theme_1.palette.snow;
}); // Typing
exports.default = SiteHeaderTool;
